import { Box, SimpleGrid } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useTranslation } from 'react-i18next';

import { TextInput } from 'components';
import { CreditOptionsResponse, CreditRequestForm, CreditResponse } from 'types';

import CreditRequestPersonalAddress from './address';
import CreditRequestPersonalChildren from './children';
import CreditRequestPersonalInfo from './info';
import CreditRequestPersonalPartner from './partner';

interface CreditRequestPersonalProps {
  credit: CreditResponse;
  form: UseFormReturnType<CreditRequestForm>;
  options: CreditOptionsResponse;
  visibleFields: string[];
}

const CreditRequestPersonal = ({
  credit,
  form,
  options,
  visibleFields,
}: CreditRequestPersonalProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <CreditRequestPersonalInfo form={form} options={options} visibleFields={visibleFields} />
      <CreditRequestPersonalAddress form={form} visibleFields={visibleFields} />
      <CreditRequestPersonalChildren credit={credit} form={form} options={options} />
      {visibleFields.includes('partnerOnSameAddress') && (
        <CreditRequestPersonalPartner form={form} options={options} visibleFields={visibleFields} />
      )}

      <Box p={'md'} mt={'sm'}>
        <SimpleGrid cols={4}>
          <TextInput
            label={t('credit.comment.singular')}
            key={form.key('comment2')}
            {...form.getInputProps('comment2')}
          />
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default CreditRequestPersonal;
